<div class="card" >
  <my-tabs >
    <my-tab [tabTitle]="'Filter Summary'" >
      <div style="margin:5px;">
        <button type="button" style="margin: 2px;" class="ct-freight_btn-primary k-button k-primary" (click)="filterSummaryList()" ><i class="mdi mdi-filter" aria-hidden="true"></i>Filter Field List</button>
        <button  type="button" class="ct-freight_btn-primary k-button k-primary"  (click)="onRefreshFilterSummary()" style="float: right; "><i class="mdi mdi-refresh " aria-hidden="true"></i>Refresh</button>
        <button type="button" class="ct-freight_btn-primary k-button k-primary" (click)="exportExcelSummaryList()"  style="float: right; margin-right: 3px;"><i class="mdi mdi-export" aria-hidden="true"></i>Export to Excel</button>
        <kendo-grid
        [data]="summaryDetailList"
        [selectable]="true"
        (dblclick)="dbClickSummary($event)"
        [height]="250"
        [columnMenu]="true"
        [sortable]="true"
        (columnVisibilityChange)="onVisibilityChange($event)">
        <kendo-grid-checkbox-column width="55" [headerStyle]="{'padding-left':'12px'}">
          <ng-template kendoGridHeaderTemplate let-dataItem>
            <input 
                type="checkbox" 
                kendoCheckBox
                name="selectAll"
                (change)="onSelectAllChange()" 
                [checked]="isCheckedAllSummaryDtl"/>
          </ng-template>
          <ng-template   kendoGridCellTemplate let-idx="rowIndex"  let-dataItem>
            <input type="checkbox"  [checked]="dataItem.isSelected"  kendoCheckBox  (change)="selectDisplayCount(idx)" />
          </ng-template>
        </kendo-grid-checkbox-column>
        <ng-template ngFor [ngForOf]="columnSummary" let-column>
          <kendo-grid-column
            title = "{{column.title}}"
            field="{{column.property}}"
            [hidden]="column.isHidden == 'true'" >
          <ng-template kendoGridColumnMenuTemplate let-service="service">
            <kendo-grid-columnmenu-sort [service]="service">
            </kendo-grid-columnmenu-sort>
            <kendo-grid-columnmenu-lock [service]="service">
            </kendo-grid-columnmenu-lock>
            <kendo-grid-columnmenu-filter [service]="service">
            </kendo-grid-columnmenu-filter>
            <kendo-grid-columnmenu-chooser [service]="service">
            </kendo-grid-columnmenu-chooser>
          </ng-template>
          </kendo-grid-column>
        </ng-template>
        </kendo-grid>
        </div>
    </my-tab>
    <my-tab [tabTitle]="'Filter List'" >
      <div style="margin:5px;">
        <!-- <ng-select [items]="client" [searchWhileComposing] = "true" [searchable]="true"  [clearSearchOnAdd] = "true"  [virtualScroll]="true"  
          bindValue = "value" bindLabel = "name"  (change)="onChangeClient($event)"  [(ngModel)]="clientCode"  style="max-width:20%;width:20%;padding: 0px;min-width: 50px;margin-top: 4px;">
          <ng-option *ngFor="let opt of client" [value]="opt.value">{{opt.name}}</ng-option>
        </ng-select> -->
      </div>
      <div style="margin:5px;" >
        <button type="button" style="margin: 1px;" class="ct-freight_btn-primary k-button k-primary" (click)="exportExcelData()" ><i class="mdi mdi-export" aria-hidden="true"></i>Export to Excel</button>
        <button type="button" style="margin: 1px;" class="ct-freight_btn-primary k-button k-primary" (click)="upload()" ><i class="mdi mdi-export" aria-hidden="true"></i>Upload</button>
        <button type="button"  style="margin: 1px;" class="ct-freight_btn-primary k-button k-primary" (click)="deleteFilter()" ><i class="mdi mdi-delete" aria-hidden="true"></i>Delete</button>
        <button  type="button" style="margin: 1px;" class="ct-freight_btn-primary k-button k-primary"  (click)="onRefresh()" style="float: right;"><i class="mdi mdi-refresh " aria-hidden="true"></i>Refresh</button>
        <button type="button"  style="margin: 1px;" class="ct-freight_btn-primary k-button k-primary"   (click)="addFilter()" style="float: right;margin-left: 5px;margin-right: 5px;" ><i class="mdi mdi-plus" aria-hidden="true"></i>Add Filter</button>
        <div class="kendoGrid k-grid tr" style="margin-top: 5px;">
          <kendo-grid
            [data]="gridViewFilterList"
            [pageSize]="state.take"
            [skip]="state.skip"
            [sortable]="true"
            [pageable]="true"
            [resizable]="true"
            [columnMenu]="true"
            [reorderable]="true"
            (pageChange)="pageChange($event)"
            (edit)="editFilter($event)" 
            [height]="300">
            <ng-template kendoGridColumnMenuTemplate let-service="service">
              <kendo-grid-columnmenu-sort [service]="service">
              </kendo-grid-columnmenu-sort>
              <kendo-grid-columnmenu-lock [service]="service">
              </kendo-grid-columnmenu-lock>
              <kendo-grid-columnmenu-filter [service]="service">
              </kendo-grid-columnmenu-filter>
              <kendo-grid-columnmenu-chooser [service]="service">
              </kendo-grid-columnmenu-chooser>
          </ng-template>
            <kendo-grid-command-column title="" width="70" [columnMenu]="false" [reorderable]="false" [locked]="true" >
              <ng-template kendoGridCellTemplate>
                  <button kendoGridEditCommand [primary]="true" style="margin: 5px;">Edit</button>
              </ng-template>
            </kendo-grid-command-column>
            <kendo-grid-column title="." width="55" [reorderable]="false" [locked]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                    <kendo-grid-columnmenu-chooser [service]="service">
                  </kendo-grid-columnmenu-chooser>
               </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
               <input type="checkbox"  name="checked" [(ngModel)]="dataItem.IsChecked"(change)="selectRuleList(dataItem)" [checked]="listRuleSelected"/>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Id" title="Rule ID" width="120"  >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientCode" title="Client Code" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="FilterName" title="Filter Name" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Priority" title="Priority" width="120" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CtClientName" title="Ct: Client Name" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CtClientRegion" title="Ct: Client Region" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CtClientCountry" title="Ct: Client Country" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CtClientCity" title="Ct: Client City" width="120" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CtClientParent" title="Ct: Client-Parent" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientName" title="Client Name" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientDivision" title="Client Division" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientSubDivision" title="Client Sub Division" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientLocation" title="Client Location" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientSubLocation" title="Client Sub Location" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientId" title="ClientId" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientAddress1" title="Address 1" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientAddress2" title="Address 2" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientCity" title="City" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientPostCode" title="Post Code" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientCounty" title="Country" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientCreatedDate" title="Created Date" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierId" title="Carrier Id" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierShortName" title="Carrier Short Name" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierFullName" title="Carrier Full Name" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierSCAC" title="Carrier SCAC" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierRegion" title="Carrier: Region" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierCountry" title="Carrier: Country" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierPaymentCentreCity" title="Carrier Payment Centre: City" width="140" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierCurrency" title="Carrier Currency" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierOperationalCity" title="Carrier Operational City" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierAddress1" title="Carrier Address1" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierAddress2" title="Carrier Address2" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierCity" title="Carrier City" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierPostcode" title="Carrier Postcode" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CarrierCreatedDate" title="Carrier CreatedDate" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClientCarrierID" title="Client Carrier ID" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="GP1" title="GP1" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="GP2" title="GP2" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="GoLiveDate" title="Go Live Date" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CreationDate" title="Creation Date" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="InvoiceNo" title="InvoiceNo" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="FreightBillDate" title="Invoice Date" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="DueDate" title="Invoice	DueDate" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="InvoiceCurrency" title="Invoice Currency" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="BilledAmount" title="Invoice Amount" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="InvoiceType" title="Invoice Type" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ApprovedAmount" title="Approved Amount" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="InvoiceRateStatus" title="Invoice Status" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="InvoiceAuditorsComments" title="Auditors Comments" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentID" title="Shipment ID" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentClientFields" title="Client Fields" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentModes" title="Shipment Mode" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentServiceType" title="Shipment Type" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentFreightTerms" title="SFreight Terms" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentDate" title="Shipment Date" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginCountryCode" title="Origin Country Code" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginState" title="Origin State" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginPostcode" title="Origin Postcode" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginCity" title="Origin City" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginAddress1" title="Origin Address1" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentOriginAddress2" title="Origin Address2" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentDestinationPostcode" title="Destination Postcode" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentDestinationPortCode" title="Destination PortCode" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentDestinationAddress1" title="Destination Address1" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentDestinationAddress2" title="Destination Address2" width="135" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentConsigneeName" title="Consignee Name" width="130" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentShipmentCurrency" title="Shipment Currency" width="130" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ShipmentShipmentAmount" title="City" width="Shipment Amount" width="135" [hidden]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-filter [service]="service">
                </kendo-grid-columnmenu-filter>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>   
        <div style="margin-right: 15px;">
          <button  class="k-button k-primary"  (click)="test(query)"  style="margin: 2px;float: right;">Test</button>
          <button  class="k-button k-primary"  (click)="manualTest()"  style="margin: 2px;float: right;">Manual Test</button>
          </div>
        </div>
        <div class="row" style="margin-top: 60px;">
          <div class="col-md-6">
            <div class="card" style="box-shadow: 0px 0px 3px 0px #b7b7b7;">
              <div class="card-body" style="height:22rem">
                <kendo-grid
                [kendoGridBinding]="rowData"
                  [pageSize]="5"
                  [skip]="stateTestResult.skip"
                  [sortable]="true"
                  [pageable]="true"
                  [resizable]="true"
                  [columnMenu]="false"
                  [reorderable]="true"
                  (pageChange)="pageChangeTestResult($event)"
                  (edit)="viewGridlist($event)" 
                  [height]="326">
                  <ng-template kendoGridColumnMenuTemplate let-service="service">
                    <kendo-grid-columnmenu-sort [service]="service">
                    </kendo-grid-columnmenu-sort>
                    <kendo-grid-columnmenu-lock [service]="service">
                    </kendo-grid-columnmenu-lock>
                    <kendo-grid-columnmenu-filter [service]="service">
                    </kendo-grid-columnmenu-filter>
                    <kendo-grid-columnmenu-chooser [service]="service">
                    </kendo-grid-columnmenu-chooser>
                </ng-template>
                  <kendo-grid-column title=" . " [width]="70" [columnMenu]="false" [reorderable]="false" [locked]="true" [headerStyle]="{'font-size':'14px','position':'relative'}">
                    <ng-template kendoGridCellTemplate>
                        <button kendoGridEditCommand [primary]="true">View</button>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="RatetrakId" title="Invoice ID" [width]="150"  [style]="{'font-size':'12px','padding-top': '5px','padding-bottom': '5px'}" [headerStyle]="{'font-size':'14px'}">
                    <ng-template kendoGridColumnMenuTemplate let-service="service">
                      <kendo-grid-columnmenu-filter [service]="service">
                      </kendo-grid-columnmenu-filter>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="RuleId" title="Filter ID" [width]="150" [style]="{'font-size':'12px','padding-top': '5px','padding-bottom': '5px'}" [headerStyle]="{'font-size':'14px'}">
                    <ng-template kendoGridColumnMenuTemplate let-service="service">
                      <kendo-grid-columnmenu-filter [service]="service">
                      </kendo-grid-columnmenu-filter>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="Priority" title="Priority" [width]="140" [style]="{'font-size':'12px','padding-top': '5px','padding-bottom': '5px'}" [headerStyle]="{'font-size':'14px'}">
                    <ng-template kendoGridColumnMenuTemplate let-service="service">
                      <kendo-grid-columnmenu-filter [service]="service">
                      </kendo-grid-columnmenu-filter>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="AppliedRules" title="Applied Rules" [width]="150" [style]="{'font-size':'12px','padding-top': '5px','padding-bottom': '5px'}" [headerStyle]="{'font-size':'14px'}">
                    <ng-template kendoGridColumnMenuTemplate let-service="service">
                      <kendo-grid-columnmenu-filter [service]="service">
                      </kendo-grid-columnmenu-filter>
                    </ng-template>
                  </kendo-grid-column>
                </kendo-grid>
              </div>
            </div>
          </div>
          <div class="col-md-6" style="padding-right: 0px;">
            <div class="card" style="box-shadow: 0px 0px 3px 0px #b7b7b7;">
              <div class="card-body" >
                <h3 style="background: #188cfa;
                padding: 5px;
                color: #ffffff;
                font-size: 15px;
                font-weight: 500;">Preview</h3>
                <div class="row">
                  <div class="col-md-9">
                    <div style="margin: 5px;
                    padding: 4px;">
                      <h4 style="margin-bottom: 0;
                      font-size: 13px;
                      font-weight: 600;
                      padding: 4px;">Filter:</h4>
                          <table class="table-bordered" style="font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                            <thead>
                              <tr>
                                <th style="padding-left: 8px;width: 150px;background-color: #efefef;color: #2d2d2d;height: 31px;font-size: 12px;">Name</th>
                                <th style="padding-left: 8px;width: 150px;background-color: #efefef;color: #2d2d2d;height: 31px;font-size: 12px;">Operator</th>
                                <th style="padding-left: 8px;width: 150px;background-color: #efefef;color: #2d2d2d;height: 31px;font-size: 12px;">Value</th>
                              </tr>
                            </thead>
                           <tbody>
                            <tr *ngFor="let prev of preview" >
                              <td style="width: 150px;padding: 8px;font-size: 11px;">{{prev.Field}}</td>
                              <td style="width: 150px;padding: 8px;font-size: 11px;">{{prev.Operator}}</td>
                              <td style="width: 150px;padding: 8px;font-size: 11px;">{{prev.Value}}</td>
                            </tr>
                           </tbody>
                          </table>
                     </div>
                  </div>
                  <div class="col-md-3" style="padding-left: 0px;">
                    <div style="margin: 5px;
                    padding: 4px;">
                      <h4 style="margin-bottom: 0;
                      font-size: 13px;
                      font-weight: 600;
                      padding: 4px;">Applied Rule:</h4>
                          <table class="table-bordered" style="font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                            <thead>
                              <tr>
                                <th style="padding-left: 8px;width: 150px;background-color: #efefef;color: #2d2d2d;height: 31px;font-size: 12px;">Rule Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let ar of appliedRule">
                                <td style="width: 150px;padding: 8px;font-size: 11px;">{{ar.Name}}</td>
                              </tr>
                            </tbody>
                          </table>
                     </div>
                  </div>
                </div>
               <div class="prop"  style="margin: 8px">
                <h4 style="margin-bottom: 0;font-size: 13px;font-weight: 600;padding: 4px;">Properties:</h4>
                  <span *ngFor="let apRule of appliedRule">
                      <div style="padding: 0; margin: 0;margin-bottom: -5px;margin-right: -10px;" *ngFor="let sep of previewSep" >
                        <span *ngFor="let ar of apRule.RuleProperty">
                          <span *ngIf="ar.divId == sep"> 
                            <label for="inputname" class="control-label" style="font-size: 11px;">  
                            <ng-select disabled [multiple] = "false"  class="ngSelect form-control"  [clearSearchOnAdd] = "true"  [loading]="loading"   [virtualScroll]="true"  
                              style="width: 150px;height: 29px;font-size: 11px; border-color: white;padding: 0px;"  [(ngModel)]="ar.Value">
                              <ng-option *ngFor="let item of  ar.Store" [value]="item.value">{{item.name}}</ng-option>
                            </ng-select>
                          </label>
                          </span>
                        </span>
                      </div>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </my-tab>
  </my-tabs>
</div>
  
  <kendo-window [left]="350"  *ngIf="dialogOpened" (close)="closeDialog('dialog')" [minWidth]="250" [width]="450">
    <input type="text"   class="k-textbox" style="width:400px;margin: 10px;" placeholder="Template Name"  [(ngModel)]="templateName" class="form-control " >
    <button class="k-button k-primary" style="float: right;margin-right: 10px;" kendoButton   (click)="saveTemplateDialog()">Save</button>
  </kendo-window >
  <div class="mTest">
   <kendo-window [width]="1100" [height]="400" [left]="90"   *ngIf="windowOpenedManualTest" (close)="closeManualTest()">  
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body" style="box-shadow: 0px 0px 3px 1px #dbe4db;
            height: 300px;
            padding: 5px;
            border-radius: 5px;">
              <div  style="padding: 20px; border-bottom: none;border-top: none;height: 250px;">
                <span *ngIf="ruleTemplateList.length > 0">
                      <span  *ngFor="let ruleTemp of ruleTemplateList;let i = index" [attr.data-index]="i" >
                        <div class="row">
                          <div class="col-md-10">
                            <div class="mtest">
                              <label class="control-label col-form-label " style="font-size: 11px;">
                                <ng-select   (change)="onChange(ruleTemp)" 
                                  class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                  border:none;
                                  padding: 0px;
                                  display: inline-grid;"  [(ngModel)]="ruleTemp.Entity">
                                  <ng-option *ngFor="let item of  entityDropDown" [value]="item.value">{{item.name}}</ng-option>
                                </ng-select>
                              </label>
            
                              <label class="control-label col-form-label " style="font-size: 11px;">
                                <ng-select  
                                   class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                   border:none;
                                   padding: 0px;
                                   display: inline-grid;"  [(ngModel)]="ruleTemp.Field">
                                  <ng-option *ngFor="let item of  fieldDropDown" [value]="item.value">{{item.name}}</ng-option>
                                </ng-select>
                              </label>
            
                              <label class="control-label col-form-label " style="padding-left: 5px;font-size: 11px;width: 200px;" >
                                <input type="text"  [(ngModel)]="ruleTemp.Value" class="form-control " style="width: 160px;height: 31px;font-size: 11px;border-radius: 4px;
                                border-color: #d0cdd0;" >
                              </label>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div>
                              <button class="k-button k-primary btn-info.btn-outline:hover" kendoButton  style="margin-top:10px; float: right;"  (click)="closeDiv(i)" id="{{i}}">close</button>
                            </div>
                          </div>
                        </div>
                      </span>
                </span>
              </div>
              <div style="padding-right: 10px;height: 40px;border-top: none;border-radius: 0px 0px 5px 0px;">
                  <button   class="k-button k-primary" kendoButton style="float: right;margin-right: 10px;"  (click)="addNewManualTest()"> +Field</button>
                  <button   class="k-button k-primary" kendoButton style="float: right;margin-right: 10px;"  (click)="executeManualTest()"> Execute</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body" style="box-shadow: 0px 0px 3px 1px #dbe4db;
            background: #fdfdfdcf;
            height: 300px;
            padding: 5px;
            border-radius: 5px;">
                <div style="margin:5px; border:1px solid rgba(210, 212, 210, 0.467); height: 235px;" >
                <div style="margin: 5px;">
                <input type="text" class="k-textbox"  [(ngModel)]="templateFilter"  style="width:100%;font-size: 11px;padding-left: 10px;border-radius: 5px;"  placeholder="Search Template" (ngModelChange)="searchTemplate()">
                </div>
                <div style="text-align: center;padding: 15px;font-size: 12px;color: #909090;" *ngIf="templateNameList?.length == 0">
                  <span style="margin-top: 5px;font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;"> No result found. </span> 
              </div>
                <table class="table" style="margin-top: 5px;font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                <tr *ngFor="let temp of templateNameList">
                <td style="border: none;width: 220px;padding-bottom: 0px;"><span (dblclick)="dbClickTemplate(temp)">{{ temp.Name}}</span></td>
                <td style="border: none;padding-bottom: 0px;"><span (click)="deleteTemplate1(temp)" style="cursor: pointer;"><i class="mdi mdi-delete" aria-hidden="true"></i> Delete</span></td>
                </tr>
                </table>
                </div>
                <div style="padding-top: 5px;">
                <button   class="k-button k-primary" kendoButton style="float: right;"  (click)="saveTemplate()"> Save Template</button>
                </div>
            </div>
          </div>
        </div>
       </div>
  </kendo-window>
</div>
  <kendo-window [width]="600"  *ngIf="windowOpened" (close)="close()" style="min-width: 120px;
  min-height: 100px;
  position: absolute;
  z-index: 10002;
  width: 500px;
  top: 300px;
  left: 400px;">
    <div>
      <input class="k-textbox" style="width:400px;margin: 10px;" placeholder="Invoice Id" [(ngModel)]="invoiceIds" />
      <button kendoButton class="k-button k-primary" (click)="execute()" >Execute</button>
    </div>
    <div *ngIf="jsonResult != undefined" style="overflow-x: auto; overflow-y: auto; white-space: nowrap; " >
      <ngx-json-viewer [json]="jsonResult"></ngx-json-viewer>
    </div>
  </kendo-window>
  
  <kendo-window  [title]="'Fields List'" [left]="500" [width]="500" [height]="500"  *ngIf="windowOpenedSummary" (close)="closeSummaryCount()" >  
      <kendo-panelbar>
        <kendo-panelbar-item [title]="'Clients'">
            <ng-template kendoPanelBarContent>
              <div style = "padding-left: 5px;" *ngFor = "let f of clientList" >
                <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
                  <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox    (click)="summaryOnChange(f)"/>  
                  {{f.title}}
                </label>
              </div>
            </ng-template>
        </kendo-panelbar-item>
    </kendo-panelbar>
  
    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Carrier'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of carrierList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Client Carrier'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of clientCarrierList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invoiceList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Shipment'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of shipmentList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Uoms'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of uomsList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox  (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice Charges'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invchargesList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
    
    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice Id'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invoiceIdList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Client Fields'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of clientFieldsList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Shipment Ids'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invsidList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dont display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
    <br>
    <button style="float:right" class="k-button k-primary" kendoButton (click)="DisplaySummaryCount()">OK</button>
  </kendo-window>


<kendo-excelexport [data]="allFilter" fileName="Rules.xlsx" #excelexport>
  <kendo-excelexport-column field="Id" [locked]="true" title="Filter Id" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="FilterName" title="Filter Name" [width]="350">
  </kendo-excelexport-column>
</kendo-excelexport>


<div >
  <ng-template let-filter="filter" #codingEdit>
    <coding-edit [filter]="filter"></coding-edit>
  </ng-template>
</div>


